<div class="tab-pane" role="tabpanel" id="tipocip">
        <fieldset id="agregar_tipocip" class="">
            <div class="step_section">
                <form [formGroup]="form">
                    <div class="row" id="row">
    
                        <div class="col-md-12" id="content">
                            <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                                <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                                <span id="tp_dir_message"></span>
                            </div>
                            <div class="form-horizontal">
                                <div class="form-group" align="left">
                                    <div class="col-sm-2">
                                        <label for="cert_permiso">Singularizaci&oacute;n Permiso Primitivo(<span style="color:red; font-size: 17px"></span>)</label>
                                    </div>
                                    <div class="col-sm-3" align="left">
                                        <mat-form-field class="example-full-widtsh" style="width: 145px;">
                                            <input matInput placeholder="Certificado" id="cert_permiso" name="cert_permiso" formControlName="cert_permiso" (change)="add_permiso()" [errorStateMatcher]="matcher">
                                            <mat-error *ngIf="form.controls?.cert_permiso.hasError('required')">
                                                Este campo es <strong>obligatorio</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-2" align="left">
                                        <label for="fecha_permiso" style="margin-top: 12px;">Fecha Permiso(<span style="color:red; font-size: 17px"></span>)</label>
                                    </div>
                                    <div class="input-group col-sm-2" align="left" style="padding-left: 11px;">
                                        <mat-form-field style="width: 145px">
                                            <input matInput [matDatepicker]="dp3" id="fecha_permiso" name="fecha_permiso" formControlName="fecha_permiso" (dateinput)="add_permiso($event, 'input')" (dateChange)="add_permiso( $event, 'change')">
                                            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                            <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                    </div>
                </form>
            </div>
        </fieldset>
    </div>
    <div class="separator"></div>